import React from "react";
import { Link } from "react-router";

import style from "./Header.css";

const Header = ({}) => {
  return (
    <header className={style.header}>
      <div className={style.content}>
        <div className={style.headerContent}>
          <a href="/jobs/">
            <img
              className={style.logo}
              src="/img/logo.svg" />
          </a>
        </div>
        <div className={style.nav}>
          <Link className={style.link} to={"/jobs/"}>Life at Treatwell</Link>
          <Link className={style.link} to={"/tech/"}>Technology</Link>
          <Link className={style.link} to={"/openings/"}>Join the team</Link>
        </div>
      </div>
    </header>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./component/App/Header.js